export default "﻿<div>\n    <div data-dojo-attach-point=\"tableContainer\">${translations.General__NoEntries}</div>\n</div>\n"